import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`

.HeroCTA{
  animation-fill-mode: backwards;
  -webkit-animation-fill-mode: forwards;
  animation-delay: 10ms;
  -webkit-animation: fadeIn;
  -webkit-animation-timing-function: ease-out;
  -webkit-animation-duration: 2000ms;
  animation: fadeIn;
  animation-timing-function: ease-out;
  animation-duration: 2000ms;
  -webkit-transform:translate3d(0,0,0);
}
.wrapmylist{
  width: auto;
}

.button-wrapper{
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: end;
}
.progmDetails{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px;
  gap: 6px;
  align-items: center;
}

.genre{
height: 16px;
font-family: 'Source Sans Pro';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 16px;
color: #F6F6F6;
}
.iconWrap{
  display: flex;
  align-items: center;
}
.hero-icons{
display: flex;
gap: 6px;
align-items: center;
}
@-webkit-keyframes fadeIn {
  100% { opacity: 1; }
  0% {color: #FFFFFF;
    opacity: 0; }
}
@keyframes fadeIn {
  100% { opacity: 1; }
  0% { opacity: 0; }
}

.hero-cta-title {
    white-space: nowrap;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 2.5em;
    line-height: 44px;
    Width: 340px;
    margin-bottom: 16px;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
}

.svod-exclusive-warning {
  padding-top: 8px;
  padding-bottom: 20px;
}

.hero-cta-text {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1.1em;
    height : auto;
    line-height: 26px;
    margin: 16px 0px;
    word-wrap: break-word;
    width: 527px;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
}

.hero-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 32px;
    gap: 10px;
    cursor: pointer;
    width: auto;
    height: 44px;
    background: ${colors.IconButtonPurple};
    border-radius: 8px;
    border: 0;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1.3em;
    line-height: 20px;
    color: ${colors.white};
    bottom: 80px;
    box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
}
.hero-button-link {
  width: 190px;
}
.hero-button.live {
  background: ${colors.red};
}
.hero-button.live :hover {
  background: ${colors.hoverRed};
}
.hero-button-program{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 32px;
  gap: 10px;
  cursor: pointer;
  width: max-content;
  min-width: 239px;
  height: 44px;
  background: ${colors.IconButtonPurple};
  border-radius: 8px;
  border: 0;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.3em;
  line-height: 20px;
  color: ${colors.white};
  bottom: 80px;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
}
.hero-button-program.live{
background: ${colors.red};
}
.hero-button-program.live:hover{
  background: ${colors.hoverRed};
  }
.hero-button-program:hover{
  background: ${colors.darkPurple};
}
.button-text {
    z-index: 1000000;
    color: white;
}

.force-ads-warning {
  padding-bottom: 20px;
}

  @media (max-width: 767px) {
    .HeroCTA.homepage{
      position: fixed;
      bottom: 5px;
      width: 100%;
      padding: 0px 8px 0px 8px;
    }

    .hero-cta-title {
      font-family: 'Source Sans Pro';
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      Width: 250px;
      height: auto;
      padding-bottom: 0px;
      white-space: break-spaces;
    }
    .wrapmylist{
      width: 100% !important;
    }
    a{
      width: 100%;
    }
    .progmDetails{
      margin-top: 16px;
    }

    .button-wrapper{
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
      padding-top: 10px;s
    }
    .hero-cta-text {
      font-family: 'Source Sans Pro';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      word-wrap: break-word;
      width: 100%;
      padding: 0px;
      margin-top: 16px;
      margin-bottom : 20px;
      height:auto;
  }
    .hero-button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 32px;
      gap: 10px;
      cursor: pointer;
      width: 100%;
      height: 40px;
      background: ${colors.IconButtonPurple};
      border-radius: 8px;
      border: 0;
      font-family: 'Source Sans Pro';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;
      color: ${colors.white};
      margin-bottom : 16px;
    }
    .hero-button-link {
      width: 100%;
    }
    .hero-button.live {
      background: ${colors.red};
    }
    .hero-button.live :hover {
      background: ${colors.hoverRed};
    }
    .hero-button-program{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 32px;
      gap: 10px;
      cursor: pointer;
      width: 100%;
      height: 44px;
      background: ${colors.IconButtonPurple};
      border-radius: 8px;
      border: 0;
      font-family: 'Source Sans Pro';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;
      color: ${colors.white};
    }
  }
  @media (min-width: 768px) {
    .hero-cta-title {
      font-size: 2.25em;
    }
    .hero-cta-text {
      font-size: 1em;
      line-height: 20px;
      width: 100%;
  }

}

@media (min-width: 1024px) {
  .hero-cta-wrapper-indicator.live {
    display: block;
  }
}

@media (min-width: 1200px) {
  .hero-cta-title {
    font-size: 2.5em;
  }
  .hero-cta-text {
    font-size: 1.1em;
    line-height: 26px;
  }
}
`
